var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5151 1.86212L10.4082 1.74696L10.5151 1.86212C10.7339 1.65905 10.7339 1.31288 10.5151 1.1098C10.3182 0.926974 10.0136 0.92697 9.81669 1.1098L0.707412 9.56679C0.488676 9.76986 0.488734 10.1161 0.707538 10.3191C0.904427 10.5017 1.20886 10.5017 1.40569 10.3189L10.5151 1.86212Z",
    fill: "#4D4D4D",
    stroke: "#394553",
    strokeWidth: 0.314286
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5148 9.56613L1.406 1.10994C1.20898 0.92703 0.904217 0.92709 0.707265 1.11008C0.488606 1.31323 0.488673 1.65937 0.707412 1.86244L9.81617 10.3186C10.0132 10.5015 10.318 10.5015 10.5149 10.3185C10.7336 10.1153 10.7335 9.7692 10.5148 9.56613Z",
    fill: "#4D4D4D",
    stroke: "#394553",
    strokeWidth: 0.314286
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.67f01769.svg";
export { ForwardRef as ReactComponent };